import Textarea from './textarea';

export default Textarea;
export type * from './types';
